import { Injectable, TemplateRef } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ConfirmComponent } from './confirm/confirm.component'
import { InfoComponent } from './info/info.component'
import { InputComponent } from './input/input.component'
import { ModalDialogData } from './modal'
import { ListFilesComponent } from './list-files/list-files.component'
import { TextAreaComponent } from './text-area/text-area.component'

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(public dialog: MatDialog) {}

  openInfoModal(dialogConfig: MatDialogConfig) {
    return this.dialog.open(InfoComponent, dialogConfig)
  }

  openDefaultInfoModal(data: ModalDialogData) {
    return this.dialog.open(InfoComponent, this.createDefaultConfig(data))
  }

  openConfirmModal(dialogConfig: MatDialogConfig) {
    return this.dialog.open(ConfirmComponent, dialogConfig)
  }

  openDefaultConfirmModal(data: ModalDialogData) {
    return this.dialog.open(ConfirmComponent, this.createDefaultConfig(data))
  }

  openCustomComponentModal(templateRef: TemplateRef<any>, dialogConfig: MatDialogConfig) {
    return this.dialog.open(templateRef, dialogConfig)
  }

  openInputModal(dialogConfig: MatDialogConfig) {
    return this.dialog.open(InputComponent, dialogConfig)
  }

  openTextAreaModal(dialogConfig: MatDialogConfig) {
    return this.dialog.open(TextAreaComponent, dialogConfig)
  }

  openFileListModal(dialogConfig: MatDialogConfig) {
    return this.dialog.open(ListFilesComponent, dialogConfig)
  }

  public createDefaultConfig(data: ModalDialogData) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.autoFocus = false
    dialogConfig.width = '24em'
    dialogConfig.data = data

    return dialogConfig
  }
}
